module.exports = __webpack_public_path__ + "img/joinuser3.8442b655.jpg";